if (!customElements.get('smooth-marquee')) {
  customElements.define(
    'smooth-marquee',
    class SmoothMarquee extends HTMLElement {
      constructor() {
        super();
        /** @type {HTMLDivElement} */
        this.marqueeWrap = this.querySelector('.marquee__wrap');
        /** @type {NodeListOf<HTMLDivElement>} */
        this.marqueeSegments = this.querySelectorAll('.marquee__segment');
      }
      connectedCallback() {
        requestAnimationFrame(() => {
          this.setupMarquee();
        })

        // Re-initialize marquee when content changes or window resizes.
        this.marqueeSegments.forEach((segment) => {
          const observer = new MutationObserver(() => {
            this.setupMarquee();
          })
          observer.observe(segment, { childList: true, subtree: true });
        })
        window.addEventListener('resize', this.debounce(() => this.setupMarquee(), 200))
      }
      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }
      /** Set up marquee. */
      setupMarquee() {
        if (!this.marqueeWrap || !this.marqueeSegments.length) return

          // Expand all segments to fill width of wrap and outside of viewport.
          this.marqueeSegments.forEach(segment => {
            this.expandSegmentToWidth(segment);
          });

          this.style.setProperty('--marquee-text-direction', `${this.direction === 'left' ? 'rtl' : 'ltr'}`);
          this.style.setProperty('--marquee-segment-width', `${this.segmentWidth}px`);
          this.style.setProperty('--marquee-segment-count', this.marqueeSegments.length);
          this.style.setProperty('--marquee-wrap-width', `${this.wrapWidth}px`);
          this.style.setProperty('--marquee-duration', this.calculateDuration(this.segmentWidth));
      }
      /**
       * Clone content until it fills width of wrap.
       * @param {HTMLDivElement} segment - Segment to expand.
       * */
      expandSegmentToWidth(segment) {
        const totalWidth = this.wrapWidth;
        let contentWidth = segment.offsetWidth;
        while (contentWidth < totalWidth) {
          const clone = segment.firstElementChild.cloneNode(true);
          segment.appendChild(clone);
          contentWidth += clone.offsetWidth;
        }
      }
      /**
       * Calculate duration of marquee animation based on total content width.
       * @param {number} segmentWidth - Total width of content segment.
       */
      calculateDuration(segmentWidth) {
        const wrapWidth = this.wrapWidth;
        const baseSpeed = 10;
        const duration = (segmentWidth / wrapWidth) * baseSpeed;
        return `${duration * this.speedMultiplier}s`;
      }
      get wrapWidth() {
        return this.marqueeWrap.offsetWidth;
      }
      get segmentWidth() {
        return this.marqueeSegments[0].offsetWidth;
      }
      get direction() {
        return getComputedStyle(this).getPropertyValue('--marquee-text-direction');
      }
      get speedMultiplier() {
        return parseFloat(getComputedStyle(this).getPropertyValue('--speed-multiplier'));
      }
    }
  )
}
